import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ACLStore from "lib/aclStore";

export default (store, pathName = "cardView") => ({
  path: pathName,
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "unit-planner" */ "./components"),
      import(/* webpackChunkName: "unit-planner" */ "../CardViewV2/components"),
    ]).then(([importedModule0, importedModule1]) => {
      const component = ACLStore.can("FeatureFlag:EnableNewUnitPlanFeed")
        ? importedModule1.default
        : importedModule0.default;
      return component;
    })
  ),
});
